import React from "react";
import { Routes, Route } from "react-router-dom";
import SubPage from "components/pages/organizer/sub-pages";
import type { TOrganizer } from "components/organizer/helpers/organizer-types-helper";
import { PermissionGuard } from 'components/permissions';
import Organizers from 'components/organizer';
import { Pages } from 'components/pages';

interface IOrganizerRouteProps
{
  organizer: TOrganizer | undefined;
}

const OrganizerRoute: React.FC<IOrganizerRouteProps> = ({ organizer }) =>
{
  return (
    <PermissionGuard
      permission={Organizers.Const.permissions.VIEW}
      fallback={<Pages.Page403 />}
    >
      <Routes>
        <Route path="/" element={<SubPage.OverView organizer={organizer} />} />
        <Route path="/exhibition-types/create" element={<SubPage.ExhibitionCreate organizer={organizer} />} />
        <Route path="/equipment" element={<SubPage.Equipment organizer={organizer} />} />
        <Route path="/flooring" element={<SubPage.Flooring organizer={organizer} />} />
        <Route path="/exhibition-types" element={<SubPage.Exhibition organizer={organizer} />} />
        <Route path="/stand-types" element={<SubPage.Stand organizer={organizer} />} />
      </Routes>
    </PermissionGuard>
  );
};

export default OrganizerRoute;